import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';

import { unregister } from './registerServiceWorker';

const sentryEnvironment = process.env.REACT_APP_SENTRY_ENV_NAME;
const sentryBuildNumber = process.env.REACT_APP_SENTRY_BUILD_NUMBER;

Sentry.init({
  dsn: "https://d56c6997bc6a4b6c93f774a8dfa41e82@o4504730772897792.ingest.sentry.io/4505127986003968",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: (sentryEnvironment ? sentryEnvironment : 'dev'),
  release: sentryEnvironment === 'development' ? undefined : `covr-consumer@${sentryBuildNumber}`
});
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

  unregister();
// registerServiceWorker(); //for some reason this blocked all server requests in a deployed enviornment



// WEBPACK FOOTER //
// ./src/index.js